import React from 'react'
import queryString from 'query-string'

import Admin from './admin/Admin'
import Editor from './editor/editor'
import Readonly from './readonly/readonly'
import { hosts } from '../hostAdapters/hosts'

const { Component } = React

class App extends Component {
  render () {
    const parsed = queryString.parse(this.props.queryString)

    const adminMode = parsed.mode === 'admin'
    const editorMode = parsed.mode === 'edit-dialog' || this.props.host === hosts.STANDALONE
    const Component = editorMode ? Editor : Readonly

    if (editorMode) {
      document.body.style.backgroundColor = '#afafaf'
    }

    return <div>
      <div>
        {adminMode && <Admin />}
        {!adminMode && <Component />}
      </div>
    </div>
  }
}

export default App
